/* Vantor storefront helpers: asset urls, cart count, reveal.
   app-240: add to cart lives in vantor-cart.js; money terms live on the Shopify selling plan. */
(function () {
  "use strict";

  function assetUrl(name) {
    var map = window.Vantor && window.Vantor.ASSET_URLS;
    if (map && map[name]) return map[name];
    if (map && map[name + ".jpg"]) return map[name + ".jpg"];
    return name;
  }

  function updateCartCount() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        if (window.Vantor && typeof window.Vantor.setCartCount === "function") {
          window.Vantor.setCartCount(n);
        } else {
          document.documentElement.setAttribute("data-cart", n > 0 ? "1" : "0");
          var els = document.querySelectorAll("[data-cart-count]");
          for (var i = 0; i < els.length; i++) {
            els[i].textContent = n > 0 ? String(n) : "";
          }
        }
      })
      .catch(function () {});
  }

  window.Vantor = Object.assign(window.Vantor || {}, {
    assetUrl: assetUrl,
    updateCartCount: updateCartCount
  });

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initReveal() {
    if (prefersReducedMotion() || !("IntersectionObserver" in window)) return;
    document.documentElement.classList.add("js-reveal");
    var els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add("is-in");
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateCartCount();
    initReveal();
  });
})();
